export enum WasteAssignmentValidations {
  reasonNotDefined = 'reasonNotDefined',
  counterNegative = 'counterNegative',
  wasteOrMaculatureNotDefined = 'wasteOrMaculatureNotDefined',
  required = 'required',
  wasteNotDefined = 'wasteNotDefined'
}
